import Axios from "../../../axios.js";
import {profileMenuConstants, schoolConstants} from "../../../constants/ApiConstant";


export async function saveSchool(params, page, size) {
    return Axios.post(schoolConstants.SCHOOL_SAVE, params);
}

export async function searchSchool(params, page, size) {
    return Axios.post(schoolConstants.SEARCH_SEARCH + `?page=${page}&size=${size}`, params);
}

// GET /school/{id} — full detail used to prefill the edit modal.
export async function fetchSchoolDetail(id) {
    return Axios.get(schoolConstants.SCHOOL_DETAIL + `/${id}`);
}

// PUT /school/{id} — update an existing school by id.
export async function updateSchool(id, params) {
    return Axios.put(schoolConstants.SCHOOL_DETAIL + `/${id}`, params);
}

// GET /profile-menu/active/min — active profile menus (services) for the
// multi-select in the school form. Returns [{ value: code, label: name }].
export async function fetchActiveProfileMenus() {
    return Axios.get(profileMenuConstants.FETCH_ACTIVE_MIN);
}